import { Switch } from '@affine/component';
import {
  SettingHeader,
  SettingRow,
} from '@affine/component/setting-components';
import { WorkspacePermissionService } from '@affine/core/modules/permissions';
import { useUpdateWikiStatus, useWikiStatus } from '@affine/core/modules/wiki';
import { useI18n } from '@affine/i18n';
import {
  FrameworkScope,
  useLiveData,
  useService,
  type WorkspaceMetadata,
} from '@toeverything/infra';

import { useWorkspace } from '../../../../hooks/use-workspace';
import { WikiDocs } from './wiki-docs/wiki-docs';

export const WorkspaceSettingWiki = ({
  workspaceMetadata,
}: {
  workspaceMetadata: WorkspaceMetadata;
}) => {
  const t = useI18n();
  const workspace = useWorkspace(workspaceMetadata);
  const isReadOnly = useLiveData(
    useService(WorkspacePermissionService).permission.isReadOnly$
  );

  const wikiStatus = useWikiStatus({
    workspaceId: workspaceMetadata.id,
  });

  const updateWikiStatus = useUpdateWikiStatus(workspaceMetadata.id);

  if (workspace === null) {
    return null;
  }

  return (
    <FrameworkScope scope={workspace.scope}>
      <SettingHeader
        title={t['com.affine.settings.workspace.wiki.header.title']()}
      />

      <SettingRow
        name={t['com.affine.settings.workspace.wiki.settings.activate.title']()}
        desc={t[
          'com.affine.settings.workspace.wiki.settings.activate.description'
        ]()}
      >
        <Switch
          data-testid="wiki-activate-trigger"
          checked={wikiStatus.data?.data?.enable}
          disabled={isReadOnly}
          onChange={wikiStatus => {
            updateWikiStatus.mutate({
              params: {
                workspaceId: workspaceMetadata.id,
                enable: String(wikiStatus),
              },
            });
          }}
        />
      </SettingRow>
      {wikiStatus.data?.data?.enable && <WikiDocs />}
    </FrameworkScope>
  );
};
